import { NavLink, Outlet } from 'react-router-dom';
import { Landmark, ArrowDownToLine, PieChart, Send, FileText, Undo2, Percent, CalendarCheck } from 'lucide-react';

// The /money section (TRACON-MONEY-SPEC §6 §9.5): sweep, allocate, pay,
// statements share one shell, the way /admin does. Each surface adds a
// SUB_NAV entry and a child route.
const SUB_NAV = [
  { to: '/money', label: 'This week', Icon: CalendarCheck, end: true },
  { to: '/money/trust', label: 'Trust', Icon: Landmark },
  { to: '/money/sweep', label: 'Sweep', Icon: ArrowDownToLine },
  { to: '/money/allocate', label: 'Allocate', Icon: PieChart },
  { to: '/money/pay', label: 'Pay', Icon: Send },
  { to: '/money/statements', label: 'Statements', Icon: FileText },
  { to: '/money/refunds', label: 'Refunds', Icon: Undo2 },
  { to: '/money/commissions', label: 'Commissions', Icon: Percent },
];

export default function MoneyLayout() {
  return (
    <div className="min-h-screen">
      <div className="border-b border-border px-4 pt-4">
        <h1 className="text-xs font-semibold uppercase tracking-[0.18em] text-text-muted">Money</h1>
        <nav className="mt-3 flex gap-1 overflow-x-auto">
          {SUB_NAV.map(({ to, label, Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end === true}
              className={({ isActive }) =>
                [
                  'flex items-center gap-2 rounded-t-card border-b-2 px-3 py-2 text-sm min-h-[40px] whitespace-nowrap',
                  isActive
                    ? 'border-accent text-accent'
                    : 'border-transparent text-text-muted hover:text-text',
                ].join(' ')
              }
            >
              <Icon size={16} strokeWidth={1.5} />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
      </div>
      <Outlet />
    </div>
  );
}
